/** Mirrors backend/utils/pricingDefaults.js — used if GET /settings/pricing fails. */
export const PRICING_FALLBACK = {
  cotisation: {
    ebanking: { adultChf: 40, adultEur: 40, u14Chf: 30, u14Eur: 30, u5Chf: 0, u5Eur: 0 },
    twint: { adultChf: 40, adultEur: null, u14Chf: 30, u14Eur: null, u5Chf: 0, u5Eur: null },
    revolut: { adultChf: 40, adultEur: 40, u14Chf: 30, u14Eur: 30, u5Chf: 0, u5Eur: 0 },
    credit: { adultChf: 40, adultEur: 40, u14Chf: 30, u14Eur: 30, u5Chf: 0, u5Eur: 0 },
  },
  juventusCard: {
    ebanking: { chf: 20, eur: 20 },
    twint: { chf: 20, eur: null },
    revolut: { chf: 20, eur: 20 },
    credit: { chf: 21, eur: 21 },
  },
};

export const PAYMENT_ROW_KEYS = ['ebanking', 'twint', 'revolut', 'credit'];
